import { render } from "./CToggle.vue?vue&type=template&id=bbdd483c&scoped=true&ts=true"
import script from "./CToggle.vue?vue&type=script&lang=ts"
export * from "./CToggle.vue?vue&type=script&lang=ts"

import "./CToggle.vue?vue&type=style&index=0&id=bbdd483c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbdd483c"]])

export default __exports__